'use client';

import { Flex, Icon, Text } from '@chakra-ui/react';
import { TbAlertSquareRounded } from 'react-icons/tb';

type ErrorMessageProps = {
  message: string;
};

const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <Flex width="full" color="#ec7063" borderRadius="md" align="center">
      <Icon mr="5px" w="15px" h="15px">
        <TbAlertSquareRounded />
      </Icon>
      <Text fontSize="14px">{message}</Text>
    </Flex>
  );
};

export default ErrorMessage;
